import React, { createContext, useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";

export const ThemeContext = createContext({
  mode: "light",
  toggleColorMode: () => {},
});

export function ThemeContextProvider({ children }) {
  const [mode, setMode] = useState(() => {
    // Get saved preference from localStorage or default to light
    const savedMode = localStorage.getItem("themeMode");
    return savedMode || "light";
  });

  useEffect(() => {
    // Save preference to localStorage whenever it changes
    localStorage.setItem("themeMode", mode);
  }, [mode]);

  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    [mode]
  );

  return (
    <ThemeContext.Provider value={colorMode}>
      {children}
    </ThemeContext.Provider>
  );
}

ThemeContextProvider.propTypes = {
  children: PropTypes.node,
};
